import {
  CustomerUser,
  CustomerUserInviteStatus,
} from "../../features/customer/types/queries";
import { CoreUser } from "../../features/user/types/entities";

export const sortCustomerUsers = (a: CustomerUser, b: CustomerUser) => {
  // a user is inactive if they are not enabled and their invite status is not uninvited
  const aIsInactive =
    !a.account.enabled &&
    a.account.customerUserInviteStatus !== CustomerUserInviteStatus.UNINVITED;
  const bIsInactive =
    !b.account.enabled &&
    b.account.customerUserInviteStatus !== CustomerUserInviteStatus.UNINVITED;

  // move inactive users (aIsInactive or bIsInactive) to the bottom of the list
  if (aIsInactive && !bIsInactive) return 1;
  if (!aIsInactive && bIsInactive) return -1;

  // sort by last name in alphabetical order
  return a.account.lastName.localeCompare(b.account.lastName, "fi");
};

export const compareUsersByLastName = (a: CoreUser, b: CoreUser) =>
  a.account.lastName.localeCompare(b.account.lastName);

export const compareCustomerUsersByEnabled = (
  a: CustomerUser,
  b: CustomerUser,
) => {
  if (a.account.enabled && !b.account.enabled) return -1;
  if (!a.account.enabled && b.account.enabled) return 1;
  return 0;
};

export const getCoreUserFullName = (user: CoreUser) => {
  return `${user.account.firstName} ${user.account.lastName}`;
};
